import { API_ADMIN_URL } from "../../config/constants";
import { postRequest } from "../API";


/*********************************************************
* Function Name : list
* Description   : Get list of all advisory board members
*********************************************************/
export const list = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}cms/advisory/list`,
            postData: options
        }
        const res = await postRequest(params);
        if (res.status === true || res.status === 200) {
            return { status: true, result: res?.data?.response?.result, count: res?.data?.response?.count };
        } else {
            return { status: false, message: res?.response?.data?.statusMessage }
        }
    } catch (error) {
        console.log("Error", error);
        return { status: false, message: "Under Maintenance, Please try after some time." }
    }
}


/*********************************************************
* Function Name : addeditdata
* Description   : Add or edit an advisory board member
*********************************************************/
export const addeditdata = async (options) => {
    try {
        const params = {
            url: `${API_ADMIN_URL}${options.url}`,
            postData: options.postData
        }
        const res = await postRequest(params);
        if(res.status === true || res.status === 200){
            return { status: true, result: res?.data?.response?.result};
        }else{
            return {status: false, message: res?.response?.data?.statusMessage}
        }
    }
    catch (error) {
     console.log("Error", error);
     return {status: false, message: "Under Maintenance, Please try after some time."}
    }
};//End of Function


/*********************************************************
* Function Name : changeStatus
* Description   : Toggle an advisory board member's Active/Inactive status
*********************************************************/
export const changeStatus = async (options) => {
    try{
    const {url, postData ={}} = options;
    const params = {
      url: `${API_ADMIN_URL}${url}`,
      postData: {
        ...postData,
        ipAddress: sessionStorage.getItem("IP_ADDRESS")
      }
    }
    const res = await postRequest(params);
    if(res.status === true || res.status === 200){
        return {status: true, result: res?.data?.response?.result};
    }else{
        return {status: false, result: res?.response?.data?.statusMessage};
    }
    }catch(error){
        console.log("Error", error);
        return {status: false, message: "Under Maintenance, Please try after some time"};
    }
}


/*********************************************************
* Function Name : deleteAdvisory
* Description   : Delete an advisory board member
*********************************************************/
export const deleteAdvisory = async (options) => {
    try{
    const params = {
        url: `${API_ADMIN_URL}cms/advisory/delete`,
        postData: {
            ...options,
            ipAddress: sessionStorage.getItem('IP_ADDRESS')
        }
    }
    const res = await postRequest(params);
    if(res.status === true || res.status === 200){
        return {status: true, result: res?.data?.response?.result};
    }else{
        return {status: false, message: res?.response?.data?.statusMessage}
    }
    }catch(error){
        console.log("ERORR", error);
        return {status: false, message: "Under Maintenance, Please try after some time"}
    }
}
